<template>
  <sweet-modal
    slot="default"
    ref="delete-confirmation-modal"
    class="ba-w-100"
    width="400px"
    hide-close-button
    style="padding: 0px"
  >
    <div class="ba-card-alert ba-error ba-w-100 ba-h-100">
      <p class="ba-mg-t-1">{{ title || $t("ct-confirm-delete") }}</p>
      <span>{{ descriptionText }}</span>
      <div class="ba-buttons">
        <button class="ba-btn ba-md" @click="close()">
          {{ $t("ct-cancel") }}
        </button>
        <button class="ba-btn ba-md ba-red" @click="confirm()">
          {{ confirmMessage || $t("ct-delete-yes") }}
        </button>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";

export default {
  components: {
    SweetModal,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    confirmMessage: {
      type: String,
      default: "",
    },
    hasExternalPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    descriptionText() {
      if (this.hasExternalPopup)
        return this.$t("ct-when-delete-website-with-external-popup");

      if (this.text && this.text.trim() !== "") return this.text;

      return this.$t("ct-delete");
    },
  },
  methods: {
    open() {
      this.$refs["delete-confirmation-modal"].open();
      // this.isOpen = true;
    },
    close() {
      this.$emit("cancel");
      this.$refs["delete-confirmation-modal"].close();
      // this.isOpen = false;
    },
    confirm() {
      this.$emit("confirm");
      this.$refs["delete-confirmation-modal"].close();
      // this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ba-card-alert {
  border-radius: 8px;
  flex-direction: column;
  align-items: start;
  gap: 15px;
  max-width: 306px;
  padding: 0px;
  display: flex;
  position: relative;
  top: 0px;
  left: 0px;
  .ba-btn {
    border-radius: 10px;
    outline: none;
    border: none;
    cursor: pointer;
    font-weight: 600;
    text-transform: uppercase;
    transition: 0.4s;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 9.6px;
    padding: 6.4px 12.8px;
    font-size: 12px;

    &:hover {
      text-decoration: none;
    }

    &.ba-red {
      background-color: #fa4b57;
      color: #fff;
    }
  }
  .ba-buttons {
    display: flex;
    gap: 16px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/DeleteConfirmationModal.vue